<template>
  <div class="Login">

    <el-container class="LoginBox">
      <el-header class="LoginBox-header">
        <img
            alt=""
            src="@/assets/login_logo.png"
            srcset="@/assets/login_logo@2x.png 2x"
        />
      </el-header>

      <el-main v-if="!submited" class="LoginBox-main">
        <h1>{{ $t('lostPassword.title') }}</h1>
        <p>
          {{ $t('lostPassword.titleDescription') }}
        </p>
        <el-form
            ref="forgotPassewordForm"
            label-position="top"
            v-loading.fullscreen.lock="loading"
            :element-loading-text="$t('portals.list.chargementDonnees')"
            :model="forgotPasseword"
            :rules="forgotPassewordFormRules"
            @submit-valid="submit"
            @submit-error="onError"
        >
          <el-form-item prop="username">
            <template slot="label">{{ $t('lostPassword.username') }}</template>
            <el-input
                type="text"
                v-model="forgotPasseword.username"
                :placeholder="$t('lostPassword.usernamePlaceholder')"
            />
          </el-form-item>
          <!--<div v-if="error">{{ error }}</div>-->
          <el-button
              class="Login-formSubmit w-100"
              native-type="submit"
              type="danger"
          >{{ $t('lostPassword.confirm') }}
          </el-button
          >
        </el-form>
      </el-main>
      <el-main v-else class="LoginBox-main">
        <h1>{{ $t('lostPassword.confirmationTitle') }}</h1>
        <p>
          {{ $t('lostPassword.confirmationText') }}
        </p>
      </el-main>

      <el-footer class="LoginBox-footer" height="auto">
        <h3>{{ $t('lostPassword.backToLogin') }}</h3>
        <router-link to="login" class="LoginBox-reinitPassword">
          <el-link>{{ $t('lostPassword.backToLoginLink') }}</el-link>
        </router-link>
      </el-footer>
    </el-container>

    <div class="Login-slogan" v-if="browserContext.up('xl')">
      <img
          alt=""
          :src="require(`@/assets/${loginSlogan}.png`)"
          :srcset="require(`@/assets/${loginSlogan}@2x.png`) + ' 2x'"
      />
    </div>

    <languages></languages>

    <div class="Login-footer">
      <a :href="websiteUrl" target="_blank" rel="noopener">{{ $t('general.ubiflowWebsite') }}</a>
    </div>
  </div>
</template>

<script>
import { resetPassword } from '@/services/auth'
import { Divider } from 'element-ui'
import i18next from 'i18next'
import Languages from '../components/Languages'


export default {
  name: 'Login',
  components: { Languages, ElDivider: Divider },
  inject: ['browserContext'],
  metaInfo () {
		if (this.$t) {
      return {
        title: this.$t('lostPassword.metaTitle'),
        htmlAttrs: {
          class: 'Root--login'
        }
      }
    } else {
      return {
        title: 'lostPassword.metaTitle',
        htmlAttrs: {
          class: 'Root--login'
        }
      }
    }
  },
  data () {
    if (this.$t) {
      return {
        response: {},
        submited: false,
        loading: false,
        error: null,
        forgotPasseword: {},
        forgotPassewordFormRules: {
          username: { required: true, message: this.$t('validator.usernameRequired') }
        }
      }
    } else {
      return {
        response: {},
        submited: false,
        loading: false,
        error: null,
        forgotPasseword: {},
        forgotPassewordFormRules: {
          username: { required: true, message: 'validator.usernameRequired' }
        }
      }
    }
  },
  methods: {
    onError (error) {
      this.error = error
    },
    async submit () {
			  if (this.$ga) {
        this.$ga.event('page_login', 'clic', 'mot_de_passe_oublie')
      }
      this.loading = true
      this.response = await resetPassword(this.forgotPasseword.username)
      this.loading = false
      this.submited = true
    }
  },
  computed: {
    websiteUrl () {
      return processEnvConfig.VUE_APP_UBIFLOW_WEBSITE_URL
    },
    loginSlogan () {
      if (i18next.language === 'mx') {
        return 'login_slogan_es'
      }
      return 'login_slogan_' + i18next.language
    }
  }
}
</script>

<style lang="scss">
@import "@/theme/_bootstrap.scss";

html.Root--login {
  &,
  body {
    height: 100%;
  }

  body {
    align-items: center;
    background: url("~@/assets/login_background.jpg");
    @include image-retina("~@/assets/login_background.jpg", 2880, 1620);
    background-position: center center;
    background-size: cover !important;
    background-attachment: fixed;
    background-repeat: no-repeat;
    display: flex;
    flex: 1;
    justify-content: center;
    padding: 0;
    @media screen and (max-height: 760px) {
      align-items: flex-start;
    }
  }
}

.Login {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .LoginBox {
    @extend .card, .mx-4, .mb-5;
    max-width: 420px;
    margin-top: map-get($spacers, 5) * 2 !important;
    @media screen and (max-height: 760px) {
      margin-top: 60px + map-get($spacers, 5) * 2 !important;
    }

    h1 {
      border-bottom: 1px solid $blue;
      @include media-breakpoint-down(xs) {
        // Cannot use @extend in media
        padding-bottom: map-get($spacers, 4) !important; // pb-4
      }
    }

    &-header {
      position: absolute;
      text-align: center;
      transform: translateY(-100%);
      top: map-get($spacers, 5) * -1;
      width: 100%;
      height: 60px;

      img {
        max-width: 100%;
      }
    }

    &-main {
      @extend .card-body;
    }

    &-footer {
      background: $yellow-pastel;
      @extend .card-footer;
    }

    &-reinitPassword {
      font-size: $font-size-sm-alt;
    }
  }

  &-slogan {
    @extend .font-secondary;
    color: $white;
    font-size: $font-size-base * 2;
    font-weight: lighter;
    line-height: $font-size-base * 2.5;
    position: absolute;
    right: 20%;
    text-align: center;
    top: 50%;
    transform: translate(50%, -50%);
    width: 200px;

    .fifteen {
      @extend .text-warning;
      font-size: $font-size-base * 5;
      line-height: $font-size-base * 4.5;
      display: block;
    }

    .simplify {
      @extend .text-primary;
      display: block;
    }
  }

  &-footer {
    @extend .px-4, .py-3, .text-right;
    font-size: $font-size-sm;
    background: rgba(22, 64, 77, 0.8);
    bottom: 0;
    font-weight: lighter;
    left: 0;
    position: fixed;
    right: 0;

    @media screen and (max-height: 760px) {
      position: static;
      width: 100%;
    }

    a {
      color: $white;
    }
  }
}
</style>
